import { missingControlAxios } from '../config/axiosInstances';

export interface FindMissingControlErrorsRequest {
  countryAcronym: string;
  storeAcronym: string;
  accountingDate?: string;
}

export type FindMissingControlErrorsResponse = {
  country: string;
  store: string;
  business_date: string;
  flex_bo_version: string;
  flex_pkg_version: string;
  category: string;
  detail: string;
};

export default class {
  static async findMissingControlErrors(request: FindMissingControlErrorsRequest) {
    return missingControlAxios.get<FindMissingControlErrorsResponse>(`/missing-control/error`, {
      params: request,
    });
  }
}
